import { ConsumeConfig } from 'game/extended/creatures/goblins/abilities/consume/consume'

export const consume_config: Array<ConsumeConfig> = [
    {
        available: 4,
        cooldown: 10,
        energy: 5
    }
]